import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ClearButton, Cross, ResultContent, ResultImage, ResultInfo, ResultItem, SearchBar, SearchContainer, SearchResult, Title, Type } from './SubNavSearch.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import Search_Icon from '@assets/svg/subnav_search.svg'
import StudentThumbnail from '@components/StudentThumbnail';

import Cal_Icon from "@assets/svg/calendar.svg";
import { needsServerSearch, SEARCH_DEBOUNCE_MS, toFilterTerm, toSearchTerm } from '@utils/searchTerm';


interface IProps { }

export const SubNavSearch = forwardRef((props: IProps, ref) => {
  const { client, setSelectedSchoolViewSearch, selectedSchoolViewSearch, setSchoolLeaderView, schoolLeaderView, courseClick, setCourseClick, search, clearSearch, searchResults, searchQuery } = useStore();
  const i18n = useI18n();
  //const [search, setSearch] = useState([])
  const [showSearch, setShowSearch] = useState(false)
  const [searchText, setSearchText] = useState('')
  const searchRef = useRef("");
  const oldSearch = useRef("")
  const [currentSearch, setCurrentSearch] = useState("")
  // The last term the server was asked about (dbo.Search), and the pending debounced search.
  const lastServerTerm = useRef("")
  const searchTimer = useRef<ReturnType<typeof setTimeout> | null>(null)
  // What the results are filtered by - a login/e-mail address counts as the username before the @.
  const filterTerm = toFilterTerm(currentSearch).toLowerCase()

  useImperativeHandle(ref, () => ({
    handleClickRef(username, id, displayname, type, course?) {
      handleClick(username, id, displayname, type, course)
    },
  }));

  // const handleSearch = async (e) => {
  //   searchRef.current = e.target.value
  //   if (searchRef.current && searchRef.current.length > 1 && searchText.substring(0, 2) !== searchRef.current.substring(0, 2)) {
  //     let search = await db.search(searchRef.current.substring(0, 2), true, client.UserName, "", false, 30)
  //     search = search ? search.filter(s => s.type !== "TEACHER") : []
  //     setSearch(search)
  //   }
  //   else if (searchRef.current.length < 2) {
  //     setSearch([])
  //   }
  //   setSearchText(searchRef.current)
  // }

  async function handleSearch(val = '') {
    setCurrentSearch(val)
    if (val.length > 1) oldSearch.current = val
    if (!val || val.length < 1 || val === "") {
      oldSearch.current = ""
      ResetSearch()
      return
    }
    // The whole term, once typing pauses - not just the first 2 characters (see SearchBar).
    if (searchTimer.current) clearTimeout(searchTimer.current)
    const term = toSearchTerm(val)
    if (term.length < 2) {
      lastServerTerm.current = ""
      await search(term, true, client.UserName) // clears the results
      return
    }
    if (!needsServerSearch(term, lastServerTerm.current)) return // the last answer already has every match
    searchTimer.current = setTimeout(() => {
      lastServerTerm.current = term
      search(term, true, client.UserName, null, true, client.AdminRegisterDaysBack)
    }, SEARCH_DEBOUNCE_MS)
  }

  const ResetSearch = () => {
    lastServerTerm.current = ""
    if (searchTimer.current) clearTimeout(searchTimer.current)
    if (schoolLeaderView === 7 || schoolLeaderView === null) setSchoolLeaderView(0)
    if (courseClick) {
      oldSearch.current = ""
      setSearchText(courseClick.firstname)
      setCurrentSearch(courseClick.firstname)
      setCourseClick(null)
      clearSearch()
      setSelectedSchoolViewSearch(courseClick)
    }
    else {
      oldSearch.current = ""
      setSearchText("")
      setCurrentSearch("");
      clearSearch()
      setSelectedSchoolViewSearch(null)
    }
  }

  useEffect(() => {
    // The input's value is bound to currentSearch, not searchText - clearing
    // only searchText here (e.g. when a top tab click resets the selection
    // via setSelectedSchoolViewSearch(null)) left the visible search box
    // showing the old text.
    if (selectedSchoolViewSearch === null) {
      setSearchText("")
      setCurrentSearch("")
      oldSearch.current = ""
    }
    else if (selectedSchoolViewSearch?.firstname !== currentSearch) {
      setSearchText(selectedSchoolViewSearch?.firstname)
      setCurrentSearch(selectedSchoolViewSearch?.firstname)
    }
  }, [selectedSchoolViewSearch])

  const handleClick = (username, id, displayname, type, course?) => {
    console.log("Clicked:", username, id, displayname, type)
    if (course)
      setCourseClick(course)
    else
      setCourseClick(null)
    setSelectedSchoolViewSearch({ username: username, id: id, firstname: displayname, lastname: "", type })
    setSearchText(displayname)
    setShowSearch(false)
    setCurrentSearch(displayname)
  } 

  return (<>
    <SearchContainer>
      <SearchBar>
        <input value={currentSearch || ''} onFocus={() => setShowSearch(true)} onChange={(e) => handleSearch(e.target.value)} placeholder={i18n.t("search")} />
        <button>
          <Search_Icon />
        </button>
        {currentSearch !== "" ? (
          <ClearButton onClick={() => ResetSearch()}>
            <Cross />
          </ClearButton>
        ) : null}
      </SearchBar>
      <SearchResult show={showSearch && searchResults?.data?.filter(s => s.displayname.toLowerCase().includes(filterTerm))?.length > 0}>
        <ResultContent>
          {searchResults?.data?.filter(s => s.displayname.toLowerCase().includes(filterTerm)).map(s => <ResultItem key={s.id} onClick={() => handleClick(s.uni_name, s.id, s.displayname, s.type)}>
            <ResultImage>
              {s.type === "STUDENT" ? <StudentThumbnail font={"1.3em"} name={s?.displayname.split("-")[1]} src={s.uni_name} /> : <Cal_Icon />}
            </ResultImage>
            <ResultInfo>
              <Title>{s.displayname}</Title>
              <Type>{s.type === "STUDENT" ? "Studerende" : "Hold"}</Type>
            </ResultInfo>
          </ResultItem>)}
        </ResultContent>
      </SearchResult>
    </SearchContainer>

  </>);
});

export default SubNavSearch;
